import { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { useLocation, Link } from "react-router-dom";

import Container from "../layout/Container";
import MobileMenu from "./MobileMenu";

import logo from "../../assets/logos/zenia_stays.svg";

export default function Navbar() {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const navRef = useRef(null);
  const itemRefs = useRef([]);

  const [pill, setPill] = useState({ left: 0, width: 0 });

  const navItems = [
    { label: "Home", href: "/" },
    { label: "Solutions", href: "/solutions" },
    { label: "Revenue Calculator", href: "/revenue-calc" },
    { label: "Browse Stays", href: "/book" },
  ];

  const isActive = (href) => {
    if (href === "/") return location.pathname === "/";
    return location.pathname.startsWith(href);
  };

  /* 🔥 FIXED ACTIVE PILL */
  useEffect(() => {
    const index = navItems.findIndex((i) => isActive(i.href));
    const el = itemRefs.current[index];

    if (el) {
      setPill({
        left: el.offsetLeft,
        width: el.offsetWidth,
      });
    }
  }, [location.pathname]);

  return (
    <>
      <header className="sticky top-0 z-header bg-bg-surface border-b border-border-soft">

        <Container className="flex items-center justify-between h-[88px]">

          {/* LOGO */}
          <Link to="/" className="flex items-center">
            <img
              src={logo}
              alt="Zenia"
              className="h-[64px] md:h-[72px] w-auto"
            />
          </Link>

          {/* NAV */}
          <div className="relative hidden md:flex">

            <nav
              ref={navRef}
              className="relative flex items-center gap-2 bg-bg-light rounded-2xl p-1"
            >
              {/* 🔥 ACTIVE PILL */}
              <motion.div
                className="absolute top-1 bottom-1 bg-white rounded-xl shadow-soft"
                animate={{
                  left: pill.left,
                  width: pill.width,
                }}
                transition={{ type: "spring", stiffness: 320, damping: 30 }}
              />

              {navItems.map((item, i) => {
                const active = isActive(item.href);

                return (
                  <Link
                    key={i}
                    ref={(el) => (itemRefs.current[i] = el)}
                    to={item.href}
                    className={`
                      relative z-10 px-4 py-2 rounded-xl
                      text-[14px] font-medium
                      transition
                      ${
                        active
                          ? "text-text-primary"
                          : "text-text-muted hover:text-text-primary"
                      }
                    `}
                  >
                    {item.label}
                  </Link>
                );
              })}
            </nav>

          </div>

          {/* CTA (UNCHANGED) */}
          <div className="hidden md:flex">
            <Link to="/contact" className="btn-primary">
              Get in touch
            </Link>
          </div>

          {/* MOBILE */}
          <button
            onClick={() => setOpen(true)}
            className="md:hidden w-11 h-11 rounded-xl border border-border-soft bg-bg-surface"
          >
            ☰
          </button>

        </Container>
      </header>

      <MobileMenu open={open} onClose={() => setOpen(false)} />
    </>
  );
}